import milestones from '~/pages/milestones/shared';

document.addEventListener('DOMContentLoaded', milestones);



// WEBPACK FOOTER //
// ./pages/projects/milestones/index/index.js